import styles from "./Slider.module.css";

interface SliderProps<T> {
	listToMap: T[];
	renderItem: (item: T, index: number) => React.ReactNode;
	currentSlide: number;
	setCurrentSlide: React.Dispatch<React.SetStateAction<number>>;
	showDots?: boolean;
	className?: string;
}

export const Slider = <T,>({
	listToMap,
	renderItem,
	currentSlide,
	setCurrentSlide,
	className,
	showDots = true,
}: SliderProps<T>) => {
	const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
		const container = e.currentTarget;
		const scrollLeft = container.scrollLeft;
		const itemWidth = container.offsetWidth;
		const newIndex = Math.round(scrollLeft / itemWidth);
		setCurrentSlide(newIndex);
	};

	const handleDotClick = (index: number) => {
		console.log(index);
		const container = document.querySelector(
			`.${styles.slidesContainer}`
		) as HTMLElement;
		if (container) {
			container.scrollTo({
				left: index * container.offsetWidth,
				behavior: "smooth",
			});
		}
	};

	return (
		<div className={`${styles.overallContainer} ${className || ""}`}>
			<div className={styles.slidesContainer} onScroll={handleScroll}>
				{listToMap.map((item, index) => (
					<div key={index} className={styles.slide}>
						{renderItem(item, index)}
					</div>
				))}
			</div>

			{showDots && (
				<div className={styles.sliderDotsContainer}>
					{listToMap.map((_, index) => (
						<div
							key={index}
							className={`${styles.dot} ${
								currentSlide === index ? styles.activeDot : ""
							}`}
							onClick={() => handleDotClick(index)}
						/>
					))}
				</div>
			)}
		</div>
	);
};
